import React, { useState, useRef, useEffect } from 'react';
import API_REST from '../../../api-rest-uruk';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Auth } from 'aws-amplify';
import ScreenWithGrids from './ScreenWithGrids';
import LoadingCard from '../../UI/LoadingCard';
import API from '../../../api-graphql';
import PageContentError, { Types } from '../../UI/PageContentError';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Snackbar } from '@material-ui/core';
import { config } from '../../../constants';
import { getUrlWithToken } from '../../../utils';

const FIRMA_FRONT_URL = config.FIRMA_FRONT_URL;

const CreateFlow = (props) => {
  const { match, config, currentRole, subgroup, context } = props;

  const documentId = match.params.number;

  const formRef = useRef(null);
  const history = useHistory();

  const [templateId, setTemplateId] = useState(null);
  const [document, setDocument] = useState();
  const [notFound, setNotFound] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(undefined);
  const [alertSeverety, setAlertSeverety] = useState(undefined);

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(undefined);
  const { t } = useTranslation();

  useEffect(() => {
    async function iniatilize () {
      let currentUser;
      try {
        currentUser = await Auth.currentAuthenticatedUser();
        let result;
        if (documentId) {
          result = await API.getDocument(documentId);
        }
        const getDoc = result.data.getDocument;
        if (getDoc === null) {
          setNotFound(true);
        }
        setDocument(getDoc);
        setUser(currentUser);
        setLoading(false);
      } catch (err) {
        console.error(err);
        window.location.reload();
      }
    }

    iniatilize();
  }, []);

  const onSubmit = async (formData, completedFlowEmails) => {
    try {
      setLoading(true);
      const stepsToSend = [];
      const currentUserEmail = user.signInUserSession.idToken.payload.email;

      const emailToFinalStep = [currentUserEmail];

      if (templateId === 'CustomFlow') {
        if (completedFlowEmails.emails) {
          completedFlowEmails.emails.forEach((email) => {
            if (email !== currentUserEmail) {
              emailToFinalStep.push(email);
            }
          });
        }
        formData.steps.forEach(elm => {
          const configStep = config.steps.find((configStep) => configStep.step.type === elm.type);

          if (!configStep.step.automatic) {
            emailToFinalStep.push(elm.email);
            const notificationStep = {
              type: 'notificationStep',
              template: 'pendingSignature',
              emails: [elm.email]
            };
            stepsToSend.push(notificationStep);
          }
          const emails = elm.email ? [elm.email] : undefined;
          stepsToSend.push({ type: elm.type, emails, alias: configStep.alias });
        });
        const allEmails = [...new Set(emailToFinalStep)];

        const transactSignStep = {
          type: 'transactSignStep'
        };
        const notificationCompletedFlow = {
          type: 'notificationStep',
          template: 'completedFlow',
          emails: allEmails
        };

        formData.steps = [...stepsToSend, transactSignStep, notificationCompletedFlow];
        const body = {
          type: 'document',
          documentId,
          templateId,
          steps: formData.steps,
          subgroups: [subgroup],
          formData: {
            ...formData,
            currentUserUsername: user.username,
            currentUserEmail,
            currentUserRol: currentRole,
            currentUserPhone: user.signInUserSession.idToken.payload.phone_number
          }
        };
        delete body.formData.steps;
        delete body.formData.finalStep;
        const createdFlow = await API_REST.createFlow(body);
        const firstSigner = createdFlow.flow.steps.find(elem => !elem.automatic);
        if (firstSigner && firstSigner.userId === user.username) {
          setTimeout(() => {
            getUrlWithToken(`${FIRMA_FRONT_URL}/sign/${createdFlow.flowId}/${firstSigner.stepId}?urlCallback=${encodeURIComponent(`${window.location.origin}/document`)}`);
          }, 10000);
        } else {
          history.push('/document');
        }
      } else {
        setLoading(true);
        const body = {
          documentId,
          templateId,
          subgroups: [subgroup],
          contextId: context.id,
          formData: {
            ...formData,
            currentUserUsername: user.username,
            currentUserEmail: user.signInUserSession.idToken.payload.email,
            currentUserRol: currentRole,
            currentUserPhone: user.signInUserSession.idToken.payload.phone_number
          }
        };

        const createdFlow = await API_REST.createFlow(body);
        const firstSigner = createdFlow.flow.steps.find(elem => !elem.automatic);
        if (firstSigner && firstSigner.userId === user.username) {
          setTimeout(() => {
            getUrlWithToken(`${FIRMA_FRONT_URL}/sign/${createdFlow.flowId}/${firstSigner.stepId}?urlCallback=${encodeURIComponent(`${window.location.origin}/document`)}`);
          }, 4000);
        } else {
          history.push('/document');
        }
      }
    } catch (err) {
      console.log(err);
      setAlertSeverety('error');
      setAlertMessage(err.message);
      setOpenAlert(true);
      setLoading(false);
    }
  };

  const parseMessage = (message = '') => {
    const messageSplited = message.split(',');
    const messages = messageSplited.map((elm) => (
      <p>{t(`createFlowErrors:${elm}`)}</p>
    ));
    return messages;
  };

  return (
    <>
      <LoadingCard open={loading} loading message='Creando flujo de firma' />
      {notFound && <PageContentError type={Types.NOT_FOUND} text={t(`error:notFound:documentNotFound`)} />}
      <Snackbar open={openAlert} autoHideDuration={6000}>
        <Alert severity={alertSeverety} variant='filled' onClose={() => setOpenAlert(false)}>
          <AlertTitle> {t(`alert:${alertSeverety}`)}</AlertTitle>
          {parseMessage(alertMessage)}
        </Alert>
      </Snackbar>
      {document && user &&
      <ScreenWithGrids
        config={config}
        onSubmit={onSubmit}
        document={document}
        loading={loading}
        formRef={formRef}
        setTemplateId={setTemplateId}
      />
      }

    </>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config,
    currentRole: state.config.currentRole,
    subgroup: state.config.subgroup,
    context: state.config.context
  };
};

export default connect(mapStateToProps, null)(CreateFlow);
